import { Step } from "react-joyride";

export const getHomeTourSteps = (): Step[] => [
  {
    target: '.welcome-header',
    content: '¡Bienvenido a Clubbers! Aquí podrás ver tu información personal y estado de membresía.',
    placement: 'bottom',
  },
  {
    target: '.stats-section',
    content: 'En esta sección encontrarás estadísticas sobre tus clases y entrenamientos.',
    placement: 'top',
  },
  {
    target: '.routines-section',
    content: 'Aquí verás tus rutinas programadas para hoy y podrás acceder a todas tus rutinas.',
    placement: 'bottom',
  },
  {
    target: '.news-feed',
    content: 'Mantente al día con las últimas noticias y actualizaciones de tu gimnasio.',
    placement: 'left',
  },
];